import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { Constant } from 'src/app/Common/constant';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { ErrorLog } from 'src/app/Model/Common/error-log';
import { RiderAcountDataDto } from 'src/app/Model/Reports/rider-acount-data-dto';
import { ShippingFareSummaryDTO } from 'src/app/Model/Reports/shipping-fare-summary-dto';
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { RiderService } from 'src/app/Service/Rider/rider.service';
import { ShippingManagerService } from 'src/app/Service/Shipping/shipping-manager.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-rider-accounts',
  templateUrl: './rider-accounts.component.html',
  styleUrls: ['./rider-accounts.component.css']
})
export class RiderAccountsComponent implements OnInit {

  riderEmail: string;
  displayedColumns: string[] = ['date', 'transNo', 'debitAmount', 'creditAmount'];
  dataSource: MatTableDataSource<RiderAcountDataDto>;
  summaryData: RiderAcountDataDto[] = [];
  createSetUpForm: UntypedFormGroup;
  constant: Constant = new Constant();
  currDate = new Date();
  totalCreditAmount: number;
  totalDebitAmount: number;

  errorLog: ErrorLog = new ErrorLog();

  // ****************************

  currentDiv = 'Daily';
  selectedValue: string;
  filterData: string[] = [];
  toDate: string;
  fromDate: string;
  firstDayOfWeek: string;
  // sumAmount: number = 0;
  sumQty: number = 0;

  debitSumAmount: number = 0;
  creditSumAmount: number = 0;

  dates: any = [];
  allOrder: RiderAcountDataDto[] = [];
  filteredData: any[] = [];

  // ****************************

  //Subscription
  private getSummaryDataSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;

  constructor(
    public persistenceService: LocalStorageService,
    private formBuilder: UntypedFormBuilder,
    private toastService: ToastrService,
    public createRiderService: RiderService,
    private apiUrl: APIFactoryEndPoints,
    private shippingManagerService: ShippingManagerService,

    public datePipe: DatePipe,

  ) {
    this.riderEmail = JSON.parse(this.persistenceService.get("google_email"));
    this.dataSource = new MatTableDataSource(this.summaryData);
  }

  ngOnInit(): void {
    this.onCreateSetUp();

    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.fromDate = moment().add(0, 'M').startOf('month').format('YYYY-MM-DD');
    this.firstDayOfWeek = this.datePipe.transform(
      this.getFirstDayOfWeek(new Date()),
      'yyyy-MM-dd'
    );
    this.filterData.push(this.toDate + ' (Today)');
    this.getAllData();
  }

  ngOnDestroy() {
    if (this.getSummaryDataSubscription !== undefined)
      this.getSummaryDataSubscription.unsubscribe();

    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();
  }

  onCreateSetUp() {
    this.createSetUpForm = this.formBuilder.group({
      fromDate: [new Date(), Validators.required],
      toDate: [new Date(), Validators.required]
    })
  }

  // onViewClick() {
  //   if (this.createSetUpForm.invalid) {
  //     this.toastService.showErrorToast(this.constant.invalidFormToast);
  //     return;
  //   }
  //   let momentFromDate = new Date(this.createSetUpForm.get('fromDate').value);
  //   let formattedFromDate = moment(momentFromDate).format("YYYY-MM-DD");

  //   let momentToDate = new Date(this.createSetUpForm.get('toDate').value);
  //   let formattedToDate = moment(momentToDate).format("YYYY-MM-DD");

  //   this.getSummaryDataSubscription = this.shippingManagerService.getShippingSummaryAccountData(this.apiUrl.getRiderAccountDataByEmail, this.riderEmail, formattedFromDate, formattedToDate).subscribe((data) => {
  //     console.log(data)
  //     this.dataSource.data = data;
  //     if (this.dataSource.data.length === 0) {
  //       this.toastService.showErrorToast(this.constant.noDataAvailableToast);
  //     }
  //     else {
  //       this.totalCreditAmount = 0;
  //       this.totalDebitAmount = 0;
  //       data.forEach((element: RiderAcountDataDto) => {
  //         if (element.type == 'Cr') {
  //           element.creditAmount = parseFloat(element.amount.toString());
  //           this.totalCreditAmount += parseFloat(element.creditAmount.toString());
  //           element.creditAmount = Number(element.creditAmount.toFixed(2));
  //         }
  //         if (element.type == 'Dr') {
  //           element.debitAmount = parseFloat(element.amount.toFixed());
  //           this.totalDebitAmount += parseFloat(element.debitAmount.toFixed());
  //           element.debitAmount = Number(element.debitAmount.toFixed(2));
  //         }
  //       });
  //     }
  //   },
  //     (error: HttpErrorResponse) => {
  //       this.insertErrorLog("onViewClick", error);
  //     });
  // }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    // this.errorLog.userId = this.persistenceService.get('userId');
    // this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    // this.errorLog.moduleName = "Shipping Date Wise Report";
    // this.errorLog.errorMethod = errorMethod;
    // this.errorLog.platform = "Web";
    // if (error?.error?.message || error?.error?.message != '')
    //   this.errorLog.errorDetails = error.error.message;
    // else
    //   this.errorLog.errorDetails = error.message;

    // this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiUrl.insertErrorLog, this.errorLog).subscribe((data: any) => {
    // });
  }

  // getAllData() {
  //   let momentFromDate = '2000-01-01';
  //   let momentToDate = '3000-01-01';

  //   this.getSummaryDataSubscription = this.shippingManagerService.getShippingSummaryAccountData(this.apiUrl.getRiderAccountDataByEmail, this.riderEmail, momentFromDate, momentToDate).subscribe((data) => {

  //     // const modifiedData = data.map(item => ({...item,date: item.date.substring(0, 10)}));

  //     this.allOrder = data;
  //     this.divClick('Daily', this.toDate, this.toDate);

  //     this.dataSource.data = data;
  //     this.totalCreditAmount = 0;
  //     this.totalDebitAmount = 0;
  //     data.forEach((element: RiderAcountDataDto) => {
  //       if (element.type == 'Cr') {
  //         element.creditAmount = parseFloat(element.amount.toString());
  //         this.totalCreditAmount += parseFloat(element.creditAmount.toString());
  //         element.creditAmount = Number(element.creditAmount.toFixed(2));
  //       }
  //       if (element.type == 'Dr') {
  //         element.debitAmount = parseFloat(element.amount.toFixed());
  //         this.totalDebitAmount += parseFloat(element.debitAmount.toFixed());
  //         element.debitAmount = Number(element.debitAmount.toFixed(2));
  //       }
  //     });
  //   });
  // }
  getAllData() {
    let momentFromDate = '2000-01-01';
    let momentToDate = '3000-01-01';
  
    this.getSummaryDataSubscription = this.shippingManagerService.getShippingSummaryAccountData(this.apiUrl.getRiderAccountDataByEmail, this.riderEmail, momentFromDate, momentToDate).subscribe((data) => {
      this.allOrder = data.map((element: RiderAcountDataDto) => {
        if (element.date) {
          element.date = element.date.replace('T', ' ');
        }
          
        if (element.type == 'Cr') {
          element.creditAmount = parseFloat(element.amount.toString());
          element.creditAmount = Number(element.creditAmount.toFixed(2));
        } else if (element.type == 'Dr') {
          element.debitAmount = element.amount;
          element.debitAmount = Number(element.debitAmount.toFixed(2));
        }
  
        if (!element.creditAmount) {
          element.creditAmount = 0;
        }

        if (!element.debitAmount) {
          element.debitAmount = 0;
        }
  
        return element;
      });
  
      this.divClick('Daily', this.toDate, this.toDate);
  
      this.dataSource.data = this.allOrder;
      this.totalCreditAmount = 0;
      this.totalDebitAmount = 0;
      this.allOrder.forEach((element: RiderAcountDataDto) => {
        if (element.type == 'Cr') {
          this.totalCreditAmount += element.creditAmount;
        }
        if (element.type == 'Dr') {
          this.totalDebitAmount += element.debitAmount;
        }
      });
    });
  }
  

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getFirstDayOfWeek(date: Date): Date {
    const day = date.getDay();
    const firstDay = new Date(date);
    firstDay.setDate(date.getDate() - day);
    return firstDay;
  }

  calculateDaysDiff(dateSent) {
    let currentDate = new Date();
    dateSent = new Date(dateSent);

    return Math.floor(
      (Date.UTC(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate()
      ) -
        Date.UTC(
          dateSent.getFullYear(),
          dateSent.getMonth(),
          dateSent.getDate()
        )) /
      (1000 * 60 * 60 * 24)
    );
  }



  divClick(divC: string, fromDate: string, toDate: string) {
    this.currentDiv = divC;
    if (divC == 'Daily') {
      document.getElementById('totDebit').innerText =
        'Total debit amount for today';
      document.getElementById('totCredit').innerText =
        'Total credit amount for today';
      document.getElementById('performanceHead').innerText =
        'Date wise performance';

      this.showBarChart(divC, fromDate, toDate);

      this.selectedValue = this.filterData[0];
    }
    if (divC == 'Weekly') {
      document.getElementById('totDebit').innerText =
        'Total debit amount in the week';
      document.getElementById('totCredit').innerText =
        'Total credit amount in the week';
      document.getElementById('performanceHead').innerText =
        'Week wise performance';

      this.filterData = [];
      let frD = moment().add(-2, 'M').startOf('month').format('YYYY-MM-DD');
      let frDt;
      let toDt;
      let k = 0;
      for (let i = 0; i < this.calculateDaysDiff(frD); i += 7) {
        frDt = moment().add(-i, 'd').startOf('week').format('YYYY-MM-DD');
        if (frDt < frD) frDt = frD;
        toDt = moment().add(-i, 'd').endOf('week').format('YYYY-MM-DD');
        if (toDt >= this.toDate) toDt = this.toDate + ' (This Week)';
        else {
          toDt = toDt + ' (Before ' + ++k + ' Week)';
        }

        this.filterData.push(frDt + ' to ' + toDt);
      }
      this.showBarChart(
        divC,
        this.filterData[0].split(' to ')[0],
        this.filterData[0].split(' to ')[1].split('(')[0]
      );
      this.selectedValue = this.filterData[0];
    }
    if (divC == 'Monthly') {
      document.getElementById('totDebit').innerText =
        'Total debit amount for the month';
      document.getElementById('totCredit').innerText =
        'Total credit amount for the month';
      document.getElementById('performanceHead').innerText =
        'Month wise performance';

      this.filterData = [];
      let frDate = moment().add(-2, 'M').startOf('month').format('YYYY-MM-DD');
      let allDate = this.getDates(
        new Date(this.datePipe.transform(frDate, 'yyyy-MM-dd')),
        new Date(this.datePipe.transform(this.toDate, 'yyyy-MM-dd'))
      );
      let trD;
      for (let i = 0; i <= 2; i++) {
        let frD = moment().add(-i, 'M').startOf('month').format('YYYY-MM-DD');
        trD = moment().add(-i, 'M').endOf('month').format('YYYY-MM-DD');
        if (i == 0) trD = this.toDate + ' (This Month)';
        if (i == 1) trD = trD + ' (In ' + this.getMonthNameFromMonthNo(Number(trD.split("-")[1])) + ')';
        if (i == 2) trD = trD + ' (In ' + this.getMonthNameFromMonthNo(Number(trD.split("-")[1])) + ')';

        this.filterData.push(frD + ' to ' + trD);
      }
      this.showBarChart(
        divC,
        this.filterData[0].split(' to ')[0],
        this.filterData[0].split(' to ')[1].split('(')[0]
      );
      this.selectedValue = this.filterData[0];
    }
  }

  getDates(startDate: Date, endDate: Date): Date[] {
    let currentDate: Date = startDate;
    this.dates = [];
    while (currentDate <= endDate) {
      this.dates.push(currentDate);
      currentDate = this.addDays(currentDate);
    }
    return this.dates;
  }

  private addDays(currentDate: Date): Date {
    let date = new Date(currentDate);
    date.setDate(date.getDate() + 1);
    return date;
  }

  getMonthNameFromMonthNo(no: number) {
    if (no == 1)
      return 'January'
    if (no == 2)
      return 'February'
    if (no == 3)
      return 'March'
    if (no == 4)
      return 'April'
    if (no == 5)
      return 'May'
    if (no == 6)
      return 'June'
    if (no == 7)
      return 'July'
    if (no == 8)
      return 'August'
    if (no == 9)
      return 'September'
    if (no == 10)
      return 'October'
    if (no == 11)
      return 'November'
    if (no == 12)
      return 'December'
  }

  onFilterSelect(data: any) {
    if (this.currentDiv == 'Daily') {
      this.showBarChart(
        this.currentDiv,
        data.split(' ')[0],
        data.split(' ')[0]
      );
    }
    if (this.currentDiv == 'Weekly' || this.currentDiv == 'Monthly') {
      this.showBarChart(
        this.currentDiv,
        data.split(' to ')[0],
        data.split(' to ')[1].split('(')[0]
      );
    }
  }

  private filterDataByDateRange(data: RiderAcountDataDto[], startDate: string, endDate: string): RiderAcountDataDto[] {
    console.log(startDate);
    console.log(endDate);

    return data.filter(item => {
      const itemDate = item.date.split(' ')[0];
      return itemDate >= startDate && itemDate <= endDate;
    });
  }

  showBarChart(source: string, fromDate: string, toDate: string) {
    if (source == 'Daily') {
      this.filterData = [];
      this.filterData.push(this.toDate + ' (Today)');
      let frDate = moment().add(-2, 'M').startOf('month').format('YYYY-MM-DD');
      let allDates = this.getDates(
        new Date(this.datePipe.transform(frDate, 'yyyy-MM-dd')),
        new Date(this.datePipe.transform(this.toDate, 'yyyy-MM-dd'))
      );
      let k = 0;
      for (let i = allDates.length - 2; i >= 0; i--) {
        this.filterData.push(
          this.datePipe.transform(allDates[i].toString(), 'yyyy-MM-dd') +
          ' (Before ' +
          ++k +
          ' day)'
        );
      }

      document.getElementById('daily').style.setProperty('color', 'white');
      document.getElementById('weekly').style.setProperty('color', 'black');
      document.getElementById('monthly').style.setProperty('color', 'black');
      
      this.debitSumAmount = 0;
      this.creditSumAmount = 0;
      if (allDates.length > 0) {
        // let startDate = this.datePipe.transform(allDates[0], 'yyyy-MM-dd');
        // let endDate = this.datePipe.transform(allDates[allDates.length - 1], 'yyyy-MM-dd');

        this.filteredData = this.filterDataByDateRange(this.allOrder, fromDate, toDate);
        this.filteredData.forEach(element => {
          this.debitSumAmount = Number((this.debitSumAmount + element.debitAmount).toFixed(2));
        })
        this.filteredData.forEach(element => {
          this.creditSumAmount = Number((this.creditSumAmount + element.creditAmount).toFixed(2));
        })
      }
    }

    if (source == 'Weekly') {
      document.getElementById('daily').style.setProperty('color', 'black');
      document.getElementById('weekly').style.setProperty('color', 'white');
      document.getElementById('monthly').style.setProperty('color', 'black');

      this.debitSumAmount = 0;
      this.creditSumAmount = 0;
      let allDates = this.getDates(
        new Date(this.datePipe.transform(fromDate, 'yyyy-MM-dd')),
        new Date(this.datePipe.transform(toDate, 'yyyy-MM-dd'))
      );

      if (allDates.length > 0) {
        // let startDate = this.datePipe.transform(allDates[0], 'yyyy-MM-dd');
        // let endDate = this.datePipe.transform(allDates[allDates.length - 1], 'yyyy-MM-dd');

        this.filteredData = this.filterDataByDateRange(this.allOrder, fromDate, toDate);
        this.filteredData.forEach(element => {
          this.debitSumAmount = Number((this.debitSumAmount + element.debitAmount).toFixed(2));
        })
        this.filteredData.forEach(element => {
          this.creditSumAmount = Number((this.creditSumAmount + element.creditAmount).toFixed(2));
        })
      }
    }

    if (source == 'Monthly') {
      document.getElementById('daily').style.setProperty('color', 'black');
      document.getElementById('weekly').style.setProperty('color', 'black');
      document.getElementById('monthly').style.setProperty('color', 'white');

      let allDates = this.getDates(
        new Date(this.datePipe.transform(fromDate, 'yyyy-MM-dd')),
        new Date(this.datePipe.transform(toDate, 'yyyy-MM-dd'))
      );

      this.debitSumAmount = 0;
      this.creditSumAmount = 0;
      if (allDates.length > 0) {
        // let startDate = this.datePipe.transform(allDates[0], 'yyyy-MM-dd');
        // let endDate = this.datePipe.transform(allDates[allDates.length - 1], 'yyyy-MM-dd');

        this.filteredData = this.filterDataByDateRange(this.allOrder, fromDate, toDate);
        this.filteredData.forEach(element => {
          this.debitSumAmount = Number((this.debitSumAmount + element.debitAmount).toFixed(2));
        })
        this.filteredData.forEach(element => {
          this.creditSumAmount = Number((this.creditSumAmount + element.creditAmount).toFixed(2));
        })

      }
    }
  }

}